import React from 'react';
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  withStyles,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { useInboundStocks } from 'hooks';
import { colors, fonts } from 'theme';

const useStyles = makeStyles(theme => ({
  clientCell: {
    width: '40%',
  },
  streamCell: {
    width: '30%',
  },
  weightCell: {
    width: '30%',
  },
  headerCell: {
    padding: '11px 22px',
    '&:not(:last-child)': {
      borderRight: `1px solid ${colors.greyLighten20}`,
    },
  },
  inboundStocksTable: {
    width: '65%',
    borderTop: `1px solid ${colors.greyLighten20}`,
    marginBottom: 25,
    height: 320,
  },
  tableContainer: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  bodyCell: {
    padding: '5px 22px',
    border: `1px solid ${colors.greyLighten20}`,
    maxHeight: 3,
    '&:first-child': {
      borderLeft: 'none',
    },
    '&:last-child': {
      borderRight: 'none',
    },
  },
}));

export type InboundStockTableProps = {
  month: number;
  year: number;
};

const StyledTableCell = withStyles({
  root: {
    fontFamily: fonts.secondary,
    fontSize: '16px',
  },
})(TableCell);

const InboundStockTable: React.FC<InboundStockTableProps> = (props: InboundStockTableProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'sortingCenters.inboundStocks' });

  const classes = useStyles();

  const [inboundStocks] = useInboundStocks(props.year, props.month);
  return (
    <div className={classes.tableContainer}>
      <TableContainer className={classes.inboundStocksTable}>
        <Table stickyHeader>
          <TableHead>
            <StyledTableCell className={`${classes.headerCell} ${classes.clientCell}`}>{t('client')}</StyledTableCell>
            <StyledTableCell className={`${classes.headerCell} ${classes.streamCell}`}>{t('stream')}</StyledTableCell>
            <StyledTableCell className={`${classes.headerCell} ${classes.weightCell}`}>{t('weight')}</StyledTableCell>
          </TableHead>
          <TableBody>
            {inboundStocks?.map(stock => (
              <TableRow key={stock.id}>
                <StyledTableCell className={`${classes.bodyCell} ${classes.clientCell}`}>
                  {stock.client.shortName}
                </StyledTableCell>
                <StyledTableCell className={`${classes.bodyCell} ${classes.streamCell}`}>
                  {stock.stream.name}
                </StyledTableCell>
                <StyledTableCell className={`${classes.bodyCell} ${classes.weightCell}`}>
                  <NumberFormat
                    decimalSeparator=","
                    decimalScale={3}
                    isNumericString
                    suffix=" t"
                    fixedDecimalScale={true}
                    displayType="text"
                    value={stock.weight / 1000}
                  />
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
export default InboundStockTable;
